import React from 'react'

const FinishedCol = ({ finished }) => {
    const isNotZeroFinished = finished.count > 0
    return (
        <p className={`department_employe_count_mobile ${finished.top > 0 && isNotZeroFinished ? "top_finished" : "default_color"}`}>{finished.count}</p>
    )
}

export default FinishedCol